import React from 'react';

class SelectField extends React.Component {
  render() {
    const {
      label,
      required,
      hint,
      value,
      onChange,
      options,
      placeholder,
      disabled,
      fieldId,
      error,
    } = this.props;
    const hasError = !!error;

    return (
      <div className="w-full" data-field-id={fieldId || undefined}>
        {label ? (
          <label className="block text-sm font-medium text-[#1F2937] mb-2">
            {label}
            {required ? <span className="text-[#DC2626] ml-1">*</span> : null}
          </label>
        ) : null}
        <select
          required={required}
          disabled={disabled}
          value={value || ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          aria-invalid={hasError || undefined}
          className="dui-select dui-select-bordered w-full bg-white text-[#1F2937] focus:outline-none focus:ring-2"
          style={{
            borderColor: hasError ? '#DC2626' : '#D1D5DB',
            outlineColor: hasError ? '#DC2626' : '#7C5CFC',
            boxShadow: hasError ? '0 0 0 1px #DC2626' : undefined,
          }}
        >
          {placeholder ? <option value="">{placeholder}</option> : null}
          {(options || []).map((opt) => {
            const optionValue = typeof opt === 'string' ? opt : opt.value;
            const optionLabel = typeof opt === 'string' ? opt : opt.label;
            return (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
        </select>
        {hasError ? (
          <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : hint ? (
          <p className="mt-1 text-xs text-[#6B7280]">{hint}</p>
        ) : null}
      </div>
    );
  }
}

export default SelectField;
